import React from 'react';
import { StyledNavItem, StyledNavItemIcon } from "../nav-section/styles";
import { ListItemText, Tooltip } from '@mui/material';
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import i18n from "../../i18n";
import ContactSupportDialog from "../../pages/dialogs/ContactSupportDialog";

const NavContactSupport = ({ collapsed }) => {
    const [dialogOpen, setDialogOpen] = React.useState(false);

    return (
        <>
            <StyledNavItem
                onClick={() => setDialogOpen(true)}
                sx={{
                    '&.active': {
                        color: 'text.primary',
                        bgcolor: 'action.selected',
                        fontWeight: 'fontWeightBold',
                    },
                    "p": 1,
                }}
            >
                {collapsed ? (
                    <Tooltip title={i18n.t('pages.contact.title')} placement="right" arrow>
                        <StyledNavItemIcon><ContactSupportIcon /></StyledNavItemIcon>
                    </Tooltip>
                ) : (
                    <StyledNavItemIcon><ContactSupportIcon /></StyledNavItemIcon>
                )}

                {!collapsed && (
                    <ListItemText disableTypography primary={i18n.t('pages.contact.title')} />
                )}

            </StyledNavItem>

            <ContactSupportDialog open={dialogOpen} onClose={() => setDialogOpen(false)} />

        </>
    );
};

export default NavContactSupport;